import type { OrderActionType } from 'state/secondaryMarket/shared/actions';

export const secondaryMarketCancellationActionsFactory = <CancelResponse, ActionType extends OrderActionType>(
  actionType: ActionType,
) => ({
  secondaryMarketCancellationWorkflowInit(orderId: string) {
    return { type: `SECONDARY_MARKET_${actionType}_CANCELLATION_WORKFLOW_INIT` as const, orderId };
  },
  secondaryMarketCancellationWorkflowAborted(orderId: string) {
    return { type: `SECONDARY_MARKET_${actionType}_CANCELLATION_WORKFLOW_ABORTED` as const, orderId };
  },
  secondaryMarketCancellationWorkflowCompleted(orderId: string) {
    return { type: `SECONDARY_MARKET_${actionType}_CANCELLATION_WORKFLOW_COMPLETED` as const, orderId };
  },

  secondaryMarketCancellationRequested(orderId: string) {
    return {
      type: `SECONDARY_MARKET_${actionType}_CANCELLATION_REQUESTED` as const,
      orderId,
    };
  },
  secondaryMarketCancelReceived(orderId: string, data: CancelResponse) {
    return {
      type: `SECONDARY_MARKET_${actionType}_CANCELLATION_RECEIVED` as const,
      orderId,
      ...data,
    };
  },
  secondaryMarketCancellationFailed(orderId: string, error?: string) {
    return {
      type: `SECONDARY_MARKET_${actionType}_CANCELLATION_FAILED` as const,
      orderId,
      error,
    };
  },
  secondaryMarketCancellationRejected(orderId: string, error?: string) {
    return {
      type: `SECONDARY_MARKET_${actionType}_CANCELLATION_REJECTED` as const,
      orderId,
      error,
    };
  },
});
